import React from 'react'
import ReviewItems from './reviewItems.jsx'
import { object, string, bool } from 'prop-types'

class ReviewsResults extends React.Component {
  render () {
    const { pageData: { pageName }, id, location, discountPage } = this.props
    let search = ''
    let meta = { }
    try {
      if (pageName.indexOf('airport-parking') > -1) {
        meta = require('../../../../../config/exports/buildTimeOnly/reviews/airportParkingReviews.json')
        search = 'airport parking'
      }
      if (pageName.indexOf('airport-hotels') > -1) {
        meta = require('../../../../../config/exports/buildTimeOnly/reviews/airportHotelsReviews.json')
        search = 'airport hotels'
      }
      if (pageName.indexOf('airport-lounges') > -1) {
        if (pageName !== 'airport-lounges' && location.code) {
          meta = require('../../../../../config/exports/buildTimeOnly/reviews/lounges/' + location.code + '.json')
        } else {
          meta = require('../../../../../config/exports/buildTimeOnly/reviews/airportLoungesReviews.json')
          search = 'airport lounges'
        }
      }
      if (discountPage) {
        meta = require('../../../../../config/exports/buildTimeOnly/reviews/parking/' + location.code + '.json')
      }
    } catch (e) {
      // Do nothing with the error
    }
    if (!(meta && meta.meta)) return null

    return (
      <span id={id} className='reviews-results'>
        <h2>Customer Reviews</h2>
        <ReviewItems reviews={meta.reviews} search={search} />
      </span>
    )
  }
}

ReviewsResults.propTypes = {
  id: string.isRequired,
  pageData: object.isRequired,
  location: object,
  discountPage: bool
}

ReviewsResults.defaultProps = {
  discountPage: false
}

export default ReviewsResults



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/reviews/reviews-results-bootstrap.jsx